import { Post } from 'lib/types';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { Chip, IconButton } from '@mui/material';
import { A } from 'components/A';
import { buildProjectPath } from 'lib/helpers';
import { SavePostToProjectsButton } from 'components/SaveToList/SavePostToProjectsButton';
import AddCircleRounded from '@mui/icons-material/AddCircleRounded';
import { useQuery } from '@tanstack/react-query';

interface Props {
    post: Post;
}

export const PostProjects = ({ post }: Props) => {
  const API = useApi();
  const currentUser = useCurrentUser();

  const { data: projects } = useQuery({
    queryKey: ['getProjectsForPost', post.id],
    queryFn: () => API.getProjectsForPost(post.id),
    enabled: !!post.id && !!currentUser,
  });

  return (
    <>
      <>
        <div className="flex flex-wrap md:flex-nowrap items-center">
          <div className="w-full md:w-4/5 py-2">
            <ul className="flex flex-wrap gap-2 list-none">
              {projects?.map((p) => (
                <Chip
                  key={p.id}
                  size="small"
                  label={(
                    <A
                      href={buildProjectPath(p)}
                      className="text-white font-bold"
                    >
                      {p.name}
                    </A>
                  )}
                  // @ts-ignore
                  color="alpineTeal"
                />
              ))}
              <IconButton
                aria-label="Add project"
                // @ts-ignore
                color="alpineTeal"
                sx={{ padding: 0 }}
              >
                <AddCircleRounded />
                <SavePostToProjectsButton styling="ml-1 text-sm font-semibold flex align-center" postId={post.id} text="Add to project" />
              </IconButton>
            </ul>
          </div>
        </div>
      </>
    </>
  );
};
